// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Icon from "@insite/mobius/Icon";
import { IconWrapper } from "@store/MobiusOverrides/Icon/Icon";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { iconColorStyles } from "@toolkit/Themes/common/mixins/icon";
import React from "react";
import styled from "styled-components";

interface QuantityAdjustButtonsProps {
    decrementDisabled?: boolean;
    incrementDisabled?: boolean;
    onDecrement: () => void;
    onIncrement: () => void;
}

interface QuantityButtonProps {
    position: "left" | "right";
}

const QuantityButton = styled.button<QuantityButtonProps>`
    position: absolute;
    display: inline-flex;
    align-items: center;
    padding: 0;
    height: 100%;
    width: ${pxToRem(18)};
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    pointer-events: auto;

    ${({ position }) => (position === "left" ? `left: ${pxToRem(4)};` : `right: ${pxToRem(4)};`)}

    &:disabled {
        cursor: not-allowed;

        ${IconWrapper} {
            ${iconColorStyles("button.disabled")}
        }
    }

    &:hover ${IconWrapper} {
        ${iconColorStyles("text.linkAltHover")}
    }
`;

const QuantityAdjustButtons = ({
    decrementDisabled,
    incrementDisabled,
    onDecrement,
    onIncrement,
}: QuantityAdjustButtonsProps) => {
    const qtyOnMouseDown = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
    };

    return (
        <>
            <QuantityButton
                position="left"
                type="button"
                aria-label={translate("Decrease quantity")}
                disabled={decrementDisabled}
                onClick={onDecrement}
                onMouseDown={qtyOnMouseDown}
                data-test-selector="qtyOrdered_decrement"
            >
                <Icon src="Minus" size={14} />
            </QuantityButton>
            <QuantityButton
                position="right"
                type="button"
                aria-label={translate("Increase quantity")}
                disabled={incrementDisabled}
                onClick={onIncrement}
                onMouseDown={qtyOnMouseDown}
                data-test-selector="qtyOrdered_increment"
            >
                <Icon src="Plus" size={14} />
            </QuantityButton>
        </>
    );
};

export default QuantityAdjustButtons;
